// Profile-score sections (server keys) to the progress labels the app routes by. "profile" spans many fields.
const SECTION_LABEL = {
  founder: 'Founder Details',
  pitch_deck: 'Pitch Deck',
  product_video: 'Product Video',
  elevator_pitch: 'Pitch Reel',
  round: 'Round Name & Type',
  documents: 'Documents',
  performance: 'Performance',
};

// What the score-change banner shows, or null when it should stay hidden.
export const scoreNoticeView = (progress) => {
  const notice = progress?.scoreNotice;
  const completion = progress?.completionPercentage ?? 0;
  if (!notice || !progress?.progressData || completion >= Number(notice.from)) return null;

  const changes = Array.isArray(notice.changes) ? notice.changes : [];
  // Best way back: a section that now counts more and is still empty.
  const gained = changes
    .filter((c) => c.to > c.from && SECTION_LABEL[c.key] && !progress.progressData[SECTION_LABEL[c.key]])
    .sort((a, b) => b.to - a.to)[0];

  return {
    from: Number(notice.from),
    to: completion,
    changes: changes.map((c) => (c.from === 0 ? `${c.label} is new and counts ${c.to}%` : `${c.label}: ${c.from}% → ${c.to}%`)),
    action: gained ? { field: SECTION_LABEL[gained.key], label: `Add ${gained.label.replace(/\b\w/g, (c) => c.toUpperCase())}`, points: gained.to } : null,
  };
};
